import React from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

import { formatDateTime } from '../../Utils/GlobalUtils';

import LoadingLines from '../../Components/LoadingLines';
import WarningPanel from '../WarningPanel';
import Loading from '../Loading';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

export default function SystemLoginRecords() {
    const navigate = useNavigate();
    const [entries, setEntries] = React.useState([]);

    const [limitForView, setLimitForView]= React.useState(50);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    const [lastUpdateTime, setLastUpdateTime] = React.useState('');

    React.useEffect(() => {
        setLoading(true);
        const token = localStorage.getItem('token');
        axios.get(`/api/last-user-logins?limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setEntries(response.data);
        })
        .catch((error) => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
            setLastUpdateTime(new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }));
        })
    }, [reload]);

  return (
    <div className='pageWrapper'>
        <div className='tableContainer'>
            <div className='tableHeaderWrapper'>
                <div className='tableStatus'>
                    <h3></h3>
                    <a className='lastUpdateWrapper'>
                        Последнее обновление таблицы: {lastUpdateTime || '--:--'} 
                        {loading ? 
                            <Loading type='inline' /> 
                        : 
                            <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                        }
                    </a>
                </div>
                <div className='tableHeader' style={{gridTemplateColumns: '30fr 25fr 25fr 10fr'}}>
                    <div>ФИО</div>
                    <div>Email</div>
                    <div>ip-адрес входа</div>
                    <div>Дата и время</div>
                </div>
            </div>
            {(entries.length===0 && loading) ? <LoadingLines />
            : warning ? <WarningPanel text={warning} inTable={true} buttonText='Повторить попытку' buttonAction={() => setReload(true)} />
            : entries.map((entry) => (
                <motion.div
                    className='tableRow nonActive' 
                    key={entry.id}
                    initial={{ scale: '97%', opacity: 0 }}
                    animate={{ scale: '100%', opacity: 1 }}
                    exit={{ scale: '97%', opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{ gridTemplateColumns: '30fr 25fr 25fr 10fr' }}
                >
                    <div>
                        <Link
                            className='aWithLink' 
                            to={`/account/${entry.user_id}`}
                        >
                            {entry.lastname} {entry.firstname} {entry.surname}
                        </Link>
                    </div>
                    <div>{entry.email}</div>
                    <div>{entry.ip_address}</div>
                    <div
                        className='monoTime'
                    >
                        {formatDateTime(entry.login_time)}
                    </div>
                </motion.div>
            ))}
            {!warning && entries.length > 0 && (entries.length < entries[0].total_count) && (
                <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                    <div></div>
                    <div>
                        <button
                            type='button'
                            className='button'
                            style={{ width: 'fit-content' }}
                            onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                            disabled={loading}
                        >
                            {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                        </button>
                    </div>
                    <div></div>
                </div>
            )}
        </div>
    </div>
  )
}
